import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import DOMPurify from 'dompurify';

const PolicyView = () => {
  const location = useLocation();
  const initialContent = location?.state?.content || '';
  const [content, setContent] = useState(initialContent);

  useEffect(() => {
    setContent(initialContent);
  }, [initialContent]);

  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html)
    };
  };

  return (
    <div className="p-6 bg-white rounded-3xl shadow-md">
      <h1 className="text-3xl font-semibold mb-6 text-[#AF9C80]">View Policy</h1>
      <div className="bg-gray-100 rounded-lg shadow-inner p-4 mb-4">
        <div dangerouslySetInnerHTML={createMarkup(content)} />
      </div>
    </div>
  );
};

export default PolicyView;